import { HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { finalize, Observable, share } from 'rxjs';

// Module-level singleton (mirrors the auth interceptor's refreshInProgress pattern): shares a
// single in-flight GET among concurrent callers requesting the exact same resource, then forgets
// it as soon as that request settles. This is NOT a response cache (see BaseMasterService for
// that) — it only prevents redundant simultaneous network calls for the same GET.
const inFlightGetRequests = new Map<string, Observable<HttpEvent<unknown>>>();

function buildRequestKey(req: HttpRequest<unknown>): string {
    const tenantId = req.headers.get('TenantId') ?? '';
    return `${tenantId}:${req.responseType}:${req.urlWithParams}`;
}

export const getDedupeInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.method !== 'GET') {
        return next(req);
    }

    const key = buildRequestKey(req);
    const inFlight = inFlightGetRequests.get(key);
    if (inFlight) {
        return inFlight;
    }

    const shared$ = next(req).pipe(
        finalize(() => inFlightGetRequests.delete(key)),
        share(),
    );

    inFlightGetRequests.set(key, shared$);
    return shared$;
};
